import React from 'react';
import PropTypes from 'prop-types';

const TitleWithIcon = ({
  children,
  iconSrc,
  iconStyle,
  titleStyle,
  ...props
}) => (
    <div className="titleWithIcon__container">
      <img className="titleWithIcon__icon" src={iconSrc} style={iconStyle}/>
      <span className="titleWithIcon__title" style={titleStyle}>{children}</span>
    </div>
  );

TitleWithIcon.propTypes = {
  /** Text for title */
  children: PropTypes.string.isRequired,
  /** Path for icon */
  iconSrc: PropTypes.string.isRequired,
  /** custom icon style */
  iconStyle: PropTypes.string,
  /** custom title style */
  titleStyle: PropTypes.string
};
TitleWithIcon.defaultProps = {};

export default TitleWithIcon;
